__turbopack_context__.v({
  "className": "josefin_sans_b5cc6651-module__m83fZa__className",
});
